// @flow

import * as React from 'react';
import styled, { type ReactComponentStyled } from 'styled-components';
import { Box } from '@latitude/box';
import { Responsive } from '@latitude/spacing';
import {
  BREAKPOINT,
  COLOR,
  MARGIN,
  PADDING
} from '@latitude/core/utils/constants';

// const Confetti1 = require(`./svg/confetti1.svg`);
// const Confetti2 = require(`./svg/confetti2.svg`);

type Props = {
  /** Specify a unique id for the HTML element. */
  id?: string,
  /** JSX content for first box. */
  box1: React.Node,
  /** JSX content for second box. */
  box2: React.Node
};

const OFFSET = '100px';

const OuterContainer = styled(Box)`
  background-color: ${COLOR.GREY6};
  padding: calc(${PADDING.P24} + ${OFFSET}) 0;
  @media (min-width: ${BREAKPOINT.MD}) {
    padding: calc(${PADDING.P24} + ${OFFSET} / 2) 0;
  }
`;

const InnerContainer = styled(Box)`
  background-color: ${COLOR.GREY4};
`;

const ContentBoxContainer = styled(Box)`
  margin: ${MARGIN.M0} ${MARGIN.MAUTO};
  padding: ${PADDING.P0} ${PADDING.P16};
  max-width: 900px;
`;

const ContentBox = styled(Box)`
  position: relative;
  border: solid 20px ${COLOR.GREY10};
  background-color: ${COLOR.WHITE};
  padding: ${PADDING.P32} 20px;
  width: 100%;
  max-width: 480px;

  :first-child {
    top: -${OFFSET};
    margin-bottom: calc(-${OFFSET} + ${MARGIN.M24});
  }

  :last-child {
    bottom: -${OFFSET};
    margin-top: -${OFFSET};
  }

  @media (min-width: ${BREAKPOINT.MD}) {
    padding: ${PADDING.P32};
    max-width: 480px;
    /* min-height: 450px; */
    :first-child {
      top: calc(-${OFFSET} / 2);
      margin-bottom: calc(-${OFFSET} / 2 + ${MARGIN.M24});
    }
    :last-child {
      bottom: calc(-${OFFSET} / 2);
      margin-top: auto;
      /* margin-top: -24px; */
    }
  }

  ul {
    margin: 0 0 0 ${MARGIN.M16};
    li {
      position: relative;
      list-style: none;
      margin: 0 0 0 ${MARGIN.M8};
      ::before {
        font-size: 36px;
        position: absolute;
        top: 0;
        left: -${MARGIN.M24};
        color: ${COLOR.BLUE_LIGHT};
        content: '•';
      }
    }
  }
`;

// const StyledConfetti1 = styled(Confetti1)`
//   display: none;
//   @media (min-width: ${BREAKPOINT.LG}) {
//     display: block;
//     position: absolute;
//     bottom: 0;
//     left: -100px;
//   }
// `;

// const StyledConfetti2 = styled(Confetti2)`
//   display: none;
//   @media (min-width: ${BREAKPOINT.LG}) {
//     display: block;
//     position: absolute;
//     top: -30px;
//     right: -95px;
//   }
// `;

const HowToApply = ({ box1, box2, id }: Props): ReactComponentStyled<Props> => (
  <OuterContainer id={id}>
    <InnerContainer>
      <ContentBoxContainer>
        <Responsive spacing={MARGIN.M24}>
          <ContentBox>
            {box1}
          </ContentBox>
          <ContentBox>
            {box2}
          </ContentBox>
        </Responsive>
      </ContentBoxContainer>
    </InnerContainer>
  </OuterContainer>
);

export default HowToApply;
